export const homeWide = {
	className: 'icon-home-wide',
	viewBox: '0 0 178.109 161.29101',
	paths: ['m 178.109,55.856 0,105.435 -38.818,0 0,-83.946 -50.236,-31.56 -50.235,31.56 0,83.946 -38.82,0 L 0,55.856 88.951,0 178.109,55.856 Z']
}
